// src/store/fields.js
// Field tokens are static in KitchenPrint — no API call needed

const KITCHENPRINT_TOKENS = [
  // Product fields
  { token: 'product_name',   label: 'fields.productName',   group: 'fields.productFields' },
  { token: 'product_number', label: 'fields.productNumber', group: 'fields.productFields' },
  { token: 'description',    label: 'fields.description',   group: 'fields.productFields' },
  { token: 'ean_code',       label: 'EAN / Barcode',        group: 'fields.productFields' },
  // Dates
  { token: 'print_date',     label: 'Dato (i dag)',          group: 'fields.productFields' },
  { token: 'expiry_date',    label: 'Udløbsdato',           group: 'fields.productFields' },
  { token: 'use_by_date',    label: 'Holdbar til',          group: 'fields.productFields' },
  // Kitchen specific
  { token: 'allergens',      label: 'Allergener',           group: 'fields.productFields' },
]

const state = {
  tokens:  KITCHENPRINT_TOKENS,
  loading: false,
}

const getters = {
  tokens:     (s) => s.tokens,
  tokenMap:   (s) => {
    return s.tokens.reduce((acc, t) => {
      acc[t.token] = t
      return acc
    }, {})
  },
  byGroup:    (s) => {
    return s.tokens.reduce((acc, t) => {
      const g = t.group || 'Other'
      if (!acc[g]) acc[g] = []
      acc[g].push(t)
      return acc
    }, {})
  },
}

const mutations = {
  SET_TOKENS(state, tokens)   { state.tokens  = tokens },
  SET_LOADING(state, val)     { state.loading = val    },
}

const actions = {
  // No API call needed — tokens are static
  async fetchTokens({ commit }) {
    commit('SET_TOKENS', KITCHENPRINT_TOKENS)
    return KITCHENPRINT_TOKENS
  },
}

export default { namespaced: true, state, getters, mutations, actions }